import { render, staticRenderFns } from "./incometax.vue?vue&type=template&id=30d810c2&scoped=true"
import script from "./incometax.vue?vue&type=script&lang=js"
export * from "./incometax.vue?vue&type=script&lang=js"
import style0 from "./incometax.vue?vue&type=style&index=0&id=30d810c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d810c2",
  null
  
)

export default component.exports